var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_1055_39566)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 0C41.3 0 52.1 10.8 52.1 24C52.1 37.3 41.3 48.1 28 48.1C14.8 48.1 4 37.3 4 24C4 10.8 14.8 0 28 0ZM28 5.29999C17.7 5.29999 9.3 13.7 9.3 24C9.3 34.4 17.7 42.8 28 42.8C38.4 42.8 46.8 34.4 46.8 24C46.8 13.7 38.4 5.29999 28 5.29999Z",
    fill: "url(#paint0_linear_1055_39566)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5812 40.621C27.2785 45.5019 40.2277 42.7265 44.7696 33.6345C49.3115 24.6383 46.8956 12.9623 37.7152 7.79425C28.6314 2.53049 17.2283 4.63598 11.6234 14.685C6.01855 24.734 9.884 35.6443 18.5812 40.621Z",
    fill: "url(#paint1_linear_1055_39566)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4785 15.5156L28.5 21.6602L31.5215 15.5156H36.5996L31.4453 24.6816L36.7393 34H31.6104L28.5 27.7412L25.3896 34H20.248L25.5547 24.6816L20.3877 15.5156H25.4785Z",
    fill: "url(#paint2_radial_1055_39566)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_1055_39566",
    x: 0,
    y: 0,
    width: 56.1016,
    height: 56.1016,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1055_39566"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1055_39566",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1055_39566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1055_39566",
    x1: 3.97721,
    y1: 48.0796,
    x2: 3.97721,
    y2: -0.0385123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1055_39566",
    x1: 8.98199,
    y1: 42.9839,
    x2: 8.98199,
    y2: 4.96957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E88FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#1626AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0E9F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1055_39566",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4144 0.0440858) scale(34.081 63.7645)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.73213dc9a7c04dd1862167f82a2dc3da.svg";
export { ForwardRef as ReactComponent };